import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
import {
  VAVE,
  IL1APPROVEBYPD,
  IL1APPROVEBYSOURCING,
  IL2APPROVAL,
} from "../../../Pages/AppConstant";
import { sourcingEmpIds } from "../switch_on_userlist";

function AlertDialogForm({ request, setRefreshApi }) {
  const [inputValue, setInputValue] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseAlert = () => setOpenAlert(false);

  const currentEmpId = localStorage.getItem("empid");
  const handleSubmit = async (status) => {
    // Validate first
    if (inputValue.trim() === "") {
      setOpenAlert(true);
      return;
    }
    setRefreshApi(true);
    const formData = new FormData();

    /////prd
       if (currentEmpId === "300088") {
      formData.append("il2_sourcing_comment", inputValue);
      formData.append("il2_sourcing_status", status);
      formData.append("dept", "Sourcing");
    } else if (currentEmpId === "300321") {
      formData.append("il2_pd_comment", inputValue);
      formData.append("il2_pd_status", status);
      formData.append("dept", "PD");
    } else if (currentEmpId === "300158") {
      formData.append("il2_quality_comment", inputValue);
      formData.append("il2_quality_status", status);
      formData.append("dept", "Quality");
    } else if (currentEmpId === "300503") {
      formData.append("il2_costing_comment", inputValue);
      formData.append("il2_costing_status", status);
      formData.append("dept", "Costing");
    } else if (currentEmpId === "300539") {
      formData.append("il2_marketing_comment", inputValue);
      formData.append("il2_marketing_status", status);
      formData.append("dept", "Marketing");
    } else if (
      currentEmpId === "300665" ||
      currentEmpId === "300016" ||
      currentEmpId === "300450"
    ) {
      formData.append("il2_manuf_comment", inputValue);
      formData.append("il2_manuf_status", status);
      formData.append("dept", "Manuf");
    }





///// dev
    // if (currentEmpId === "300757") {
    //   formData.append("il2_sourcing_comment", inputValue);
    //   formData.append("il2_sourcing_status", status);
    //   formData.append("dept", "Sourcing");
    // } else if (currentEmpId === "EL_0003") {
    //   formData.append("il2_pd_comment", inputValue);
    //   formData.append("il2_pd_status", status);
    //   formData.append("dept", "PD");
    // } else if (currentEmpId === "FL_0001") {
    //   formData.append("il2_quality_comment", inputValue);
    //   formData.append("il2_quality_status", status);
    //   formData.append("dept", "Quality");
    // } else if (currentEmpId === "HTL_0039") {
    //   formData.append("il2_costing_comment", inputValue);
    //   formData.append("il2_costing_status", status);
    //   formData.append("dept", "Costing");
    // } else if (currentEmpId === "FL_0003") {
    //   formData.append("il2_marketing_comment", inputValue);
    //   formData.append("il2_marketing_status", status);
    //   formData.append("dept", "Marketing");
    // } else if (
    //   currentEmpId === "FL_0006" ||
    //   currentEmpId === "FL_0004" ||
    //   currentEmpId === "FL_0005"
    // ) {
    //   formData.append("il2_manuf_comment", inputValue);
    //   formData.append("il2_manuf_status", status);
    //   formData.append("dept", "Manuf");
    // }

    formData.append("ideadata_id", request?.id_x ?? "");

    try {
      setIsLoading(true);

      await axios.post(VAVE + IL2APPROVAL, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Submitted successfully!");
      // Optionally clear state or notify parent here
      setInputValue("");

      setRefreshApi(true);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setOpenAlert(false);
      setRefreshApi(true);

      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      <label htmlFor="comment" style={{ display: "block", marginBottom: 8 }}>
        Comment*
      </label>

      <TextField
        id="comment"
        placeholder="Enter comment"
        fullWidth
        required
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        size="small"
      />

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleSubmit("accepted")}
          style={{ marginRight: "10px" }}
          disabled={isLoading}
        >
          Accept
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={() => handleSubmit("rejected")}
          disabled={isLoading}
        >
          Reject
        </Button>
      </div>

      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter a comment before accepting or rejecting. This field is
            mandatory.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialogForm;
